import { useEffect } from "react";

function PageTitle({ title }) {

  useEffect(() => {

    document.title = title
      ? `G360 | ${title}`
      : "G360";

  }, [title]);

  return null;
}

export default PageTitle;